import { CloseCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Divider, Table, Tooltip } from 'antd';
import moment from 'moment-business-days';
import React, { Component } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { hideOfflineMerge } from '../../../actions';
import { ROLES } from '../../../constants/AuthConstants';
import { doOrdersMerge } from '../../../electron/tools';
import { getRolename } from '../../../lib/AuthUtils';
import { simpleDateTimeFormat } from '../../../lib/DateFormat';
import CatalogOrderMergeDetail from './catalog-order-merge-detail';


const OrderTypeContext = React.createContext();

class CatalogOrderMergeModal extends Component {
  constructor(props) {
    super(props);

    const { t } = this.props

    const rolename = getRolename(this.props.auth);

    this.state = {
      isClient: rolename === ROLES.CLIENT,
      actions: [],
      ordersToReview: [],
      quotationsToReview: []
    }

    this.structColumns = [
      {
        title: <Trans i18nKey='translations:Reference' />,
        dataIndex: 'referencia',
        key: 'referencia',
        show: true
      },
      {
        title: <Trans i18nKey='translations:Client' />,
        dataIndex: 'apellido_nombre',
        key: 'apellido_nombre',
        show: (rolename === ROLES.CLIENT) ? false : true,
        render: (text, record) => {
          return (
            (record.cliente) ? record.cliente.nombre : ''
          )
        }
      },
      {
        title: <Trans i18nKey='translations:Update date' />,
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        show: true,
        render: (text, record) => {
          return (
            moment(record.updatedAt).format(simpleDateTimeFormat)
          )
        }
      },
      {
        key: 'action',
        width: 80,
        show: true,
        render: (text, record) => {
          return (
            <div>
              <OrderTypeContext.Consumer>
                {type =>
                <Tooltip title={t('Discard')}>
                  <a ref={this.saveRef}
                    onClick={() => this.discard(record, type)}
                  >
                    <CloseCircleOutlined />
                  </a>
                </Tooltip>
                }
              </OrderTypeContext.Consumer>

              <Divider type='vertical' />

              <OrderTypeContext.Consumer>
                {type =>
                  <Tooltip title={t('Save as new')}>
                    <a ref={this.saveRef}
                      onClick={() => this.saveAsNew(record, type)}
                    >
                      <SaveOutlined />
                    </a>
                  </Tooltip>
                }
              </OrderTypeContext.Consumer>

            </div>
          );
        },
      }

    ];

    this.columns = this.getColumns()
  }

  discard(record, type) {
    const {actions} = this.state 
    this.setState({
      actions: [
        ...actions,
        { id: record._id, type, action: 'discard' }
      ]
    })
  }

  saveAsNew(record, type) {
    const { actions } = this.state
    this.setState({
      actions: [
        ...actions,
        { id: record._id, type, action: 'save' }
      ]
    })
  }

  getColumns() {
    let result = []
    this.structColumns.forEach((column) => {
      if (column.show) {
        result.push(column)
      }
    });
    return result
  }

  onOk() {
    doOrdersMerge(this.state.actions)
    this.onCancel();
  }

  onCancel() {
    this.props.hideOfflineMerge()
    this.setState({
      actions: [
      ]
    })
  }

  render() {
    
    const { t, ordersToMerge } = this.props
    const { actions } = this.state

    let ordersToReview = []
    let quotationsToReview = []
    let ordersToReviewTable = []
    let quotationsToReviewTable = []

    if (ordersToMerge){
      ordersToReview = ordersToMerge.pedidosToMerge
      quotationsToReview = ordersToMerge.cotizaciontesToMerge
      ordersToReviewTable = ordersToReview.filter(order => !actions.find( action => action.id == order._id ))
      quotationsToReviewTable = quotationsToReview.filter(order => !actions.find( action => action.id == order._id ))
    }
    

    return (
      <div>

        {
          ordersToReviewTable.length > 0 &&
          <div>
            <h4 style={{ marginLeft: '8px' }} >{t('Orders')}</h4>
            <OrderTypeContext.Provider value={'order'}>
              <Table
                className="updates-table"
                columns={this.columns}
                dataSource={ordersToReviewTable}
                rowKey={record => record.id}
                expandedRowRender={(record) => <CatalogOrderMergeDetail order={record} isQuotation={false}/> }
                pagination={{ hideOnSinglePage: true, showSizeChanger: false }}
              />
            </OrderTypeContext.Provider>
          </div>
        }

        {
          ordersToReviewTable.length == 0 && ordersToReview.length > 0 &&
          <div style={{ height: '50px' }}>
            <h4 style={{ marginLeft: '8px' }} >{t('Orders')}</h4>
            <h6 style={{ lineHeight: '50px', textAlign: 'center' }}>
              <Trans>Done</Trans>
            </h6>
          </div>
        }

        {
          quotationsToReviewTable.length > 0 &&
          <div>
            <h4 style={{ marginLeft: '8px' }} >{t('Quotations')}</h4>
            <OrderTypeContext.Provider value={'quotation'}>
              <Table
                className="updates-table"
                columns={this.columns}
                dataSource={quotationsToReviewTable}
                rowKey={record => record.id}
                expandedRowRender={(record) => <CatalogOrderMergeDetail order={record} isQuotation={true} />}
                pagination= {{hideOnSinglePage: true, showSizeChanger: false}}
              />
            </OrderTypeContext.Provider>
          </div>
        }

        {
          quotationsToReviewTable.length == 0 && quotationsToReview.length > 0 &&
          <div>
            <h4 style={{ marginLeft: '8px' }} >{t('Quotations')}</h4>
            <div style={{ height: '50px' }}>
              <h6 style={{ lineHeight: '50px', textAlign: 'center' }}>
                <Trans>Done</Trans>
              </h6>
            </div>
          </div>
        }

        {
          (
            ordersToReviewTable.length == 0 && ordersToReview.length > 0 || 
            quotationsToReviewTable.length == 0 && quotationsToReview.length > 0
          ) && 
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <Button type="default" onClick={() => this.onCancel()} style={{marginRight: '10px'}}>
              <Trans>Cancel</Trans>
            </Button>
            <Button type="default" onClick={() => this.onOk()}>
              <Trans>Accept</Trans>
            </Button>
          </div>
        }

        
      </div>
    );
  }
}

const mapStateToProps = ({ auth, catalog }) => {
  const { user } = auth;
  const { ordersToMerge } = catalog;
  return { user, ordersToMerge, auth };
};

export default connect(mapStateToProps, {
  hideOfflineMerge
})(withTranslation()(CatalogOrderMergeModal));

